<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">Integracje</h3>
        <div class="d-flex flex-row gap-3">
            <mat-form-field appearance="outline">
                <mat-label style="color: gray;">Szukaj...</mat-label>
                <input matInput (keyup)="doFilter($event)">
            </mat-form-field>
        </div>
        <div class="d-flex flex-row gap-3 flex-fill justify-content-end">
            <button mat-flat-button class="big-button btn-with-icon" color="accent" (click)="addIntegration()">
                <mat-icon class="big-icon">add</mat-icon> Dodaj integrację</button>
            <button mat-flat-button class="big-button" color="accent" (click)="fetchIntegrations()">
                <mat-icon class="big-icon m-0">refresh</mat-icon>
            </button>
        </div>

    </div>


    <table mat-table matSort [dataSource]="dataSource" class="common-table">

        <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

        <!-- name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nazwa </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- type Column -->
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Typ </th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>

        <!-- cardUuid Column -->
        <ng-container matColumnDef="cardUuid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> CARD UUID </th>
            <td mat-cell *matCellDef="let element"> {{element.cardUuid}} </td>
        </ng-container>

        <!-- pin Column -->
        <ng-container matColumnDef="activationTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Aktywacja</th>
            <td mat-cell *matCellDef="let element"> {{ element.activationTime }}</td>
        </ng-container>

        <!-- active Column -->
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Aktywny</th>
            <td mat-cell *matCellDef="let element"> {{ getStatus(element)}}</td>
        </ng-container>


        <!-- Symbol Column -->
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
                <div class="action-cell">
                     <button type="button" class="btn btn-primary btn-action"
                    (click)="router.navigate(['integrations/edit', element.id])" matTooltip="Edytuj kartę"><mat-icon
                        aria-hidden="false" aria-label="Edytuj" fontIcon="edit"></mat-icon></button>
                </div>
            </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <br>
    <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons aria-label="Wybierz stronę">
    </mat-paginator>


</div>